import { UserType } from '../../store/slice/User';

const AnalyticsPushStaffLogin = (user: UserType) => {
	window.dataLayer = window.dataLayer || [];
	const teacherLogin = {
		event: 'teacher_login',
		user_id: user.id,
		organisation_id: user.profiles?.[0].organisationId,
		organisation_name: user.profiles?.[0].name,
		login_time: new Date().toISOString(),
		platform_type: 'staff_platform',
		event_category: 'Authentication',
		event_action: 'Login Success'
	};
	window.dataLayer.push(teacherLogin);
};

const AnalyticsPushStudentLogin = (user: UserType) => {
	window.dataLayer = window.dataLayer || [];
	const studentLogin = {
		event: 'student_login',
		user_id: user.id,
		organisation_id: user.profiles?.[0].organisationId,
		organisation_name: user.profiles?.[0].name,
		login_time: new Date().toISOString(),
		platform_type: 'student_platform',
		event_category: 'Authentication',
		event_action: 'Login Success'
	};
	window.dataLayer.push(studentLogin);
};

const AnalyticsPushStudentsCreated = ({ user, studentData }: { user: UserType; studentData: { count: number } }) => {
	window.dataLayer = window.dataLayer || [];
	const studentsCreated = {
		event: 'create_students',
		teacher_id: user.id,
		organisation_id: user.profiles?.[0].organisationId,
		organisation_name: user.profiles?.[0].name,
		// student_ids: studentData.studentIds,
		student_count: studentData.count,
		creation_timestamp: new Date().toISOString(),
		event_category: 'User Management',
		event_action: 'Student Creation',
		event_label: studentData.count + ' student(s) created'
	};
	window.dataLayer.push(studentsCreated);
};

const AnalyticsPushDownloadWeeklyPlanResources = ({
	user,
	resourceData
}: {
	user: UserType;
	resourceData: { weekName: string; resourceName: string; stageName: string };
}) => {
	window.dataLayer = window.dataLayer || [];
	const downloadWeeklyPlanResources = {
		event: 'download_weekly_resource_item',
		teacher_id: user.id,
		organisation_id: user.profiles?.[0].organisationId,
		organisation_name: user.profiles?.[0].name,
		week_name: resourceData.weekName,
		resource_name: resourceData.resourceName,
		stage_name: resourceData.stageName,
		download_timestamp: new Date().toISOString(),
		event_category: 'Resource Management',
		event_action: 'Download Resource',
		event_label: resourceData.resourceName + ' - ' + resourceData.weekName
	};
	window.dataLayer.push(downloadWeeklyPlanResources);
};

const AnalyticsPushBooksAssignedToStudents = ({
	user,
	bookData,
	studentData
}: {
	user: UserType;
	bookData: { books: { book_name: string; book_id: string }[] };
	studentData: { studentId: string }[];
}) => {
	window.dataLayer = window.dataLayer || [];
	const booksAssignedToStudent = {
		event: 'book_assigned',
		books: bookData.books,
		student_ids: studentData.map((student) => student.studentId),
		teacher_id: user.profiles?.[0].id,
		organisation_id: user.profiles?.[0].organisationId,
		organisation_name: user.profiles?.[0].name,
		assignment_date: new Date().toISOString(),
		event_category: 'Education',
		event_action: 'Book Assignment',
		event_label: bookData.books.length + ' book(s) assigned to ' + studentData.length + ' student(s)'
	};
	window.dataLayer.push(booksAssignedToStudent);
};

const AnalyticsPushBookCompleted = ({
	user,
	bookData
}: {
	user: UserType;
	bookData: { book_name: string; book_id: string };
}) => {
	window.dataLayer = window.dataLayer || [];
	const bookCompleted = {
		event: 'book_completed',
		book_id: bookData.book_id,
		book_name: bookData.book_name,
		student_id: user.id,
		organisation_id: user.profiles?.[0].organisationId,
		organisation_name: user.profiles?.[0].name,
		completion_date: new Date().toISOString(),
		event_category: 'Education',
		event_action: 'Book Completion'
	};
	window.dataLayer.push(bookCompleted);
};

const AnalyticsPushHelpButtonClick = ({
	user,
	pageUrl,
	pagePath,
	pageTitle,
}: {
	user: UserType;
	pageUrl: string;
	pagePath: string;
	pageTitle: string;
}) => {
	window.dataLayer = window.dataLayer || [];
	const helpButtonClick = {
		event: 'help_button_clicked',
		page_url: pageUrl,
		page_path: pagePath,
		page_title: pageTitle,
		organisation_id: user.profiles?.[0].organisationId,
		organisation_name: user.profiles?.[0].name,
		event_category: 'Help',
		event_action: 'Button Click',
	};
	window.dataLayer.push(helpButtonClick);
}

export {
	AnalyticsPushStaffLogin,
	AnalyticsPushStudentLogin,
	AnalyticsPushStudentsCreated,
	AnalyticsPushDownloadWeeklyPlanResources,
	AnalyticsPushBooksAssignedToStudents,
	AnalyticsPushBookCompleted,
	AnalyticsPushHelpButtonClick
};
